import type { ControllerRenderProps, FieldValues, Path } from "react-hook-form";
import {
  FormControl,
  FormDescription,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/base/form/hook-form";
import {
  PercentageInput,
  type PercentageInputProps,
} from "../input/input-percentage";

export type FormPercentageFieldProps<
  TFieldValues extends FieldValues = FieldValues,
> = {
  field: ControllerRenderProps<TFieldValues, Path<TFieldValues>>;
  label?: string;
  labelClasses?: string;
  inputClasses?: string;
  description?: string;
  className?: string;
} & PercentageInputProps;

export const FormPercentageField = <
  TFieldValues extends FieldValues = FieldValues,
>({
  label,
  labelClasses,
  description,
  isRequired,
  field,
  className,
  inputClasses,
  ...props
}: FormPercentageFieldProps<TFieldValues>) => {
  return (
    <FormItem className={className}>
      <FormLabel className={labelClasses} required={isRequired}>
        {label}
      </FormLabel>
      <FormControl>
        <PercentageInput
          {...props}
          {...field}
          aria-label={label}
          className={inputClasses}
          isRequired={isRequired}
        />
      </FormControl>
      {description && <FormDescription>{description}</FormDescription>}
      <FormMessage />
    </FormItem>
  );
};

FormPercentageField.displayName = "FormPercentageField";
